export const isArray = (value: any): boolean => {
  return value?.length !== undefined;
};

export const isArrayEmpty = (array: any[]): boolean => {
  return array.length === 0;
};
